import { DashboardLayout } from "@/components";
import { stAdminMiddleware } from "@/middleware";
import { STAdminPayments } from "@/pages/st-admin";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const SearchSchema = z.object({
	tab: z.enum(["commission", "marketplace"]).optional(),
});

export const Route = createFileRoute("/st-admin/payments/")({
	validateSearch: zodValidator(SearchSchema),
	component: () => (
		<DashboardLayout>
			<STAdminPayments />
		</DashboardLayout>
	),
	loader: stAdminMiddleware,
});
